import {
  SET_USER, LOADING, SET_ENTIDADE,
} from './mutations.type';

export default {
  [SET_USER](state, user) {
    state.user = user;
  },
  [LOADING](state, loading) {
    state.loading = loading;
  },
  [SET_ENTIDADE](state, entidade) {
    state.entidade = entidade;
  },
};
